import i18ISOCountries from 'i18n-iso-countries';
import EN from 'i18n-iso-countries/langs/en.json';
import FR from 'i18n-iso-countries/langs/fr.json';
import NL from 'i18n-iso-countries/langs/nl.json';
import { IntlShape } from 'react-intl';

/**
 * Registering locales
 */
i18ISOCountries.registerLocale(EN);
i18ISOCountries.registerLocale(FR);
i18ISOCountries.registerLocale(NL);

const {
  getNames: getNamesFn,
  getAlpha2Code: getAlpha2CodeFn,
  getSimpleAlpha2Code: getSimpleAlpha2CodeFn,
  getAlpha3Code: getAlpha3CodeFn,
  getSimpleAlpha3Code: getSimpleAlpha3CodeFn,
  ...i18ISOCountriesMethods
} = i18ISOCountries;

/**
 * Get the lang from intl object passed as parameter.
 * @param {IntlShape} intl
 * @returns {string} lang
 */
function getLangFromLocale(intl: IntlShape): string {
  // Gets ISO 639 Locale in case the locale follows IETF.
  const locale = (intl.locale || intl.defaultLocale).split('-')[0];

  if (!i18ISOCountries.langs().includes(locale)) {
    throw new Error(`Locale: "${locale}" is not registered!`);
  }

  return locale;
}

function getNames(intl: IntlShape): i18ISOCountries.LocalizedCountryNames {
  return getNamesFn(getLangFromLocale(intl));
}

function getAlpha2Code(name: string, intl: IntlShape): string {
  return getAlpha2CodeFn(name, getLangFromLocale(intl));
}

function getSimpleAlpha2Code(name: string, intl: IntlShape): string {
  return getSimpleAlpha2CodeFn(name, getLangFromLocale(intl));
}

function getAlpha3Code(name: string, intl: IntlShape): string {
  return getAlpha3CodeFn(name, getLangFromLocale(intl));
}

function getSimpleAlpha3Code(name: string, intl: IntlShape): string {
  return getSimpleAlpha3CodeFn(name, getLangFromLocale(intl));
}

export type LocalizedCountryNames = i18ISOCountries.LocalizedCountryNames;

export const Countries = {
  getNames,
  getAlpha2Code,
  getSimpleAlpha2Code,
  getAlpha3Code,
  getSimpleAlpha3Code,
  ...i18ISOCountriesMethods
};
